import { render, staticRenderFns } from "./DetalharUsoAbaDialog.vue?vue&type=template&id=640298fb&scoped=true"
import script from "./DetalharUsoAbaDialog.vue?vue&type=script&lang=js"
export * from "./DetalharUsoAbaDialog.vue?vue&type=script&lang=js"
import style0 from "./DetalharUsoAbaDialog.vue?vue&type=style&index=0&id=640298fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640298fb",
  null
  
)

export default component.exports